import { render, staticRenderFns } from "./EUserSituacao.vue?vue&type=template&id=d0579806"
import script from "./EUserSituacao.vue?vue&type=script&lang=js"
export * from "./EUserSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports